module.exports = __webpack_public_path__ + "img/amret_mobile.673538e9.jpg";